<template lang="pug">
.layout.l-default.l-suave( :class='classes' )
  k-site-header.layout-header( v-if='!noHeader' )
  w-go-down( @click.prevent='goDown' )
  .layout-main
    d-main-image( v-bind=`{ img, show }` @load='pageLoaded' )
    .main-column
      .scroll( v-bar )
        .inner
          k-hero
          k-main( :title='title' )
            //- context sensitive content
            .content( v-html='content || caption' )
    .side-column
      slot
  wp-footer.layout-footer( v-if='!noFooter' )
  overlay.layout-overlay
  sidebar.layout-sidebar( pos='left' )
  sidebar.layout-sidebar( pos='right' )
  modal
</template>

<script lang="js">
import { mapState, mapGetters, mapMutations } from 'vuex'
import LoremIpsum from 'vue-lorem-ipsum'
import DMainImage from '@/displays/d-main-image'
import KMain from '@/blocks/k-main'
import KHero from '@/blocks/k-hero'
import KSiteHeader from '@/blocks/k-site-header'
import WpFooter from '@/components/wp-footer'
import WGoDown from '@/widgets/w-go-down'
import Overlay from '@/components/overlay'
import Modal from '@/components/modal'
import Sidebar from '@/components/sidebar'
import { User, Page } from '@/mixins'
import { Logger } from '@/lib/logger'

export default {
  name: 'SuaveLayout',
  mixins: [ User, Page ],
  components: {
    LoremIpsum,
    DMainImage,
    KHero,
    KMain,
    KSiteHeader,
    WpFooter,
    WGoDown,
    Overlay,
    Modal,
    Sidebar,
  },
  props: {
    noHeader: {
      type: Boolean,
      default: false
    },
    noFooter: {
      type: Boolean,
      default: false
    },
  },
  data() {
    return {
      unsubscribe: null,
      isScrolledUp: false,
      isScrolledDown: false,
      isScrollAtTop: true,
      scroll: 0
    }
  },
  created() {
    // this.unsubscribe = this.$store.subscribe(( mutation, state ) => {
    //   if ( mutation.type === 'scrolledDown' ) {
    //     this.scrollAtTop = false
    //   } else if ( mutation.type === 'scrolledUp' ) {
    //   } else if ( mutation.type === 'scrollAtTop' ) {
    //   }
    // })
  },
  mounted() {
    document.addEventListener( 'scroll', this.onScroll )
  },
  methods: {
    ...mapMutations([ 'scrolledDown', 'scrolledUp', 'scrollAtTop' ]),
    onScroll( $event ) {
      // Logger.debug( 'onScroll', '<html>', $event )()
      const scroll = window.scrollY
      if ( scroll < this.scroll ) {
        if ( !this.isScrolledUp ) {
          this.scrolledUp( scroll )
        }
        this.isScrolledDown = false
        this.isScrolledUp = true
        if ( !scroll ) {
          if ( !this.isScrollAtTop ) {
            this.scrollAtTop()
          }
          this.isScrollAtTop = true
        }
      } else if ( scroll > this.scroll ) {
        if ( !this.isScrolledDown ) {
          this.scrolledDown( scroll )
        }
        this.isScrolledDown = true
        this.isScrolledUp = false
        this.isScrollAtTop = false
      }
      this.scroll = scroll
    },
    goDown() {
      window.scrollTo({ top: window.innerHeight / 2 })
    },
  },
  beforeDestroy() {
    document.removeEventListener( 'scroll', this.onScroll )
    // if ( this.unsubscribe ) this.unsubscribe()
  },
  computed: {
    postData() {
      return this.$store.state.post || {}
    },
    menu() {
      return this.$store.state.menus.nav || []
    },
    site() {
      return {
        title: this.$store.state.site.title || 'My Blog',
        url: this.$store.state.site.url, // TODO: or?
        description: this.$store.state.site.description,
      }
    },
    title() {
      return ( this.postData && this.postData.title &&
               this.postData.title.rendered ) || ''
    },
    caption() {
      return ( this.postData && this.postData.caption &&
               this.postData.caption.rendered ) || ''
    },
    content() {
      return ( this.postData && this.postData.content &&
               this.postData.content.rendered ) || ''
    },
    classes() {
      return [
        {
          'scrolled-down': this.isScrolledDown,
          'scrolled-up': this.isScrolledUp,
          'scroll-at-top': this.isScrollAtTop,
        },
        this.$route.meta.classes,
      ]
    }
  }
}
</script>

<style lang="scss">
@import "@/scss/breakpoint";

.layout.l-default.l-suave {
  height: unset;
  overflow-y: unset;
  --c-text: #def; /*TODO: fix*/ 
  .layout-header {
    position: fixed;
  }
  .w-go-down {
    position: fixed;
    opacity: 0;
  }
  .layout-main {
    position: relative;
    /* height: 100vh; */
    width: 100vw;
    /* display: flex; */
    /* flex-wrap: no-wrap; */
    /* align-items: stretch; */
    overflow: hidden;
    .d-main-image {
      position: fixed;
      /* transform: translateY(-50%) translateZ(-2px) scale(2.02); */
      transform: none;
    }
    .main-column {
      transition: 400ms;
      position: fixed;
      /* height: 100vh; */
      z-index: 3;
      /* flex: 2 2 66%; */
      max-width: 1024px;
      width: 66%;
      height: 100vh;
      /* display: flex; */
      /* flex-direction: column; */
      > .scroll {
        height: 100%;
        /* > .inner { */
        /*   max-height: 100%; */
        /* } */
        > .vb-dragger {
          /* z-index: 12; */
          > .vb-dragger-styler {
            background-color: rgba(255,255,255,.1);
          }
        }
        &:hover > .vb-dragger, &:focus-within > .vb-dragger, &.vb-scrolling > .vb-dragger {
          > .vb-dragger-styler {
            background-color: rgba(255,255,255,.25);
          }
        }
      }
      > .main, > main, > .scroll > .inner > .main, > .scroll > .inner > main {
        position: relative;
        .vue-lorem, .vue-lorem p {
          text-align: justify;
        }
      }
      > main, > .scroll > .inner > main {
        transition: 300ms;
        /* flex: 1 */
        min-height: 40vh;
      }
      /* > .bottom-spacer { */
      /*   height: 15em; */
      /*   @include for-mobile { */
      /*     height: 2em; */
      /*   } */
      /* } */
      .k-main > .content {
        padding: var(--s-base);
        padding-top: var(--s-xl);
        text-align: justify;
      }
    }
    .side-column {
      background: var(--c-suave-side-column, rgba(0,0,0,0.85));
      transition: 400ms;
      /* position: fixed; */
      /* top: 0; */
      /* right:0; */
      /* bottom: 0; */
      /* left: 0; */
      /* flex: 1 1 33%; */
      /* overflow: hidden; */
      /* height: 100vh; */
      /* max-height: 100vh; */
      .k-page {
        transition: 300ms;
        padding-left: 66%;
        padding-top: 50%;
        /* left: 0; */
        background: var(--c-suave-side-column, rgba(0,0,0,0.9));
        /* background: rgba(0,0,0,0.85); */
        .d-main-image {
          /* transform: translateY(-50%) translateZ(-2px) scale(2.02); */
          transform: none;
          position: fixed;
        }
        > * {
          position: relative;
          transition: 700ms;
          opacity: 1;
          z-index: 10;
        }
        .k-browser-content {
          background: rgba(0,0,0,0.5);
          box-shadow: 0 0 120px 120px rgba(0,0,0,0.5);
          > .item {
            transition: 700ms;
            background: rgba(20,20,20,0.5);
            &:hover, &:focus, &.focus {
              transition: 300ms;
              background: rgb(30,30,30);
            }
          }
        }
        > .bottom-spacer {
          height: 1em;
          
        }
      }
    }
    .k-hero{
      width: 100%;
      height: auto;
      transition: 400ms;
      @include for-desktop {
        &.fullscreen {
          height: 75%;
          min-height: 0;
          width: 100%;
        }
      }
      .k-video-viewer.fullscreen, .k-video-player.fullscreen {
        max-height: 100vh;
        > .video-player {
          max-height: 100vh;
          overflow: hidden;
        }
      }
    }
    .w-seek-minimal {
      /* .track { */
      /*   /\* border-radius: 4px; *\/ */
      /*   border-top-left-radius: 4px; */
      /*   border-bottom-right-radius: 4px; */
      /* } */
      /* .bar { */
      /*   box-shadow: 0 0 6px cyan; */
      /*   /\* border-radius: 4px; *\/ */
      /*   border-top-left-radius: 4px; */
      /*   border-bottom-right-radius: 4px; */
      /* } */
      cursor: none;
      .bar, .track, .thumb, .thumb .inner {
        border-top-right-radius: 2px;
        border-bottom-left-radius: 2px;
        border-top-left-radius: 6px;
        border-bottom-right-radius: 6px;
      }
      .bar {
        box-shadow: 0 0 6px cyan;
        /* border-radius: 4px; */
      }
      .thumb {
        width: calc( var(--s-xs) + 2 * var(--pad-slider-thumb) );
        .inner {
          width: var(--s-xs);
        }
      }
    }
  }
  &.scroll-at-top {
    .w-go-down {
      opacity: 1;
    }
    .layout-main {
      .main-column {
        /* flex: 2 2 100%; */
        max-width: 100%;
        width: 100%;
        transition: 700ms;
        > main, > .scroll > .inner > main {
          min-height: 0;
          height: 0;
          margin: 0;
          padding: 0;
          overflow: hidden;
        }
        > .scroll >  .inner {
          max-height: 100%;
        }
      }
      .side-column {
        /* flex: 0 0 0%; */
        transition: 700ms;
        z-index: 0;
        .k-page {
          /* left: -33%; */
          padding-left: 100%;
          padding-top: 100%;
          > * {
            opacity: 0;
          }
        }
      }
    }
    .k-hero {
      transition: 700ms;
      @include for-desktop {
        &.fullscreen {
          min-height: 100vh;
          width: auto;
          height: 100%;
        }
      }
    }
  }
}
</style>
